import styled from 'styled-components';
const PageWrapper = styled.div.withConfig({
  displayName: "PageWrapper",
  componentId: "sc-1lwmtj3-0"
})(["background-color:", ";width:80vw;max-width:", ";max-height:calc(100vh - 48px);overflow-y:auto;overflow-x:hidden;"], ({
  theme
}) => theme.bento.colors.background.main, p => p.width || '600px');
export default PageWrapper;